import { isDefined } from "@clipboard-health/util-ts";
import { useFacilityProfile } from "@src/appV2/Facilities/api/useFacilityProfile";

import { InstantBook } from "../constants";

export function useWorkplaceHasBookingRequestsEnabled(workplaceId?: string) {
  const isWorkplaceIdValid = isDefined(workplaceId) && workplaceId.trim() !== "";

  const { data: facilityProfile, isLoading: isLoadingFacilityProfile } = useFacilityProfile(
    {
      workplaceId: workplaceId ?? "",
      projection: "type instantBook",
    },
    {
      enabled: isWorkplaceIdValid,
    }
  );
  const { instantBook = InstantBook.OFF } = facilityProfile ?? {};

  return {
    bookingRequestsEnabled: isWorkplaceIdValid
      ? instantBook === InstantBook.REQUEST_TO_BOOK
      : false,
    isLoading: isWorkplaceIdValid ? isLoadingFacilityProfile : false,
  };
}
